import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { LoaderComponent } from './loader/loader.component';
import { ConfirmModalComponent } from 'src/app/shared/ui/confirm-modal/confirm-modal.component';

@NgModule({
  declarations: [PagetitleComponent, LoaderComponent, ConfirmModalComponent],
  imports: [
    CommonModule
  ],
  exports: [PagetitleComponent, LoaderComponent, ConfirmModalComponent]
})
export class UiModule { }
